import axios from '../../config/axios';

export function getStockMovementReport({warehouse_id, item_id, from, to}) {
    return axios().get(`/stock/warehouses/${warehouse_id}/movement/${item_id}`, { params: {from, to} })
}

export function getByItemReport(params) {
    return axios().get(`/stock/reports/by-item`, { params })
}

export function getByWarehouseReport({warehouse_id, end_at}) {
    return axios().get(`/stock/warehouses/${warehouse_id}/on-hand`, { params: {end_at} })
}

export default {
    getByItemReport,
    getStockMovementReport,
    getByWarehouseReport
}